"use client";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownSection,
  DropdownTrigger,
} from "@nextui-org/react";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import React from "react";
import SortBy from "../../../assets/svg/SortBy";
import FilterCourses from "../../../components/FilterCourses";
import { SearchBox, SearchInput, Stack } from "../../../components/molecules";
import { SearchIcon } from "../../../components/molecules/SearchIcon";
import { useDictionary } from "../../../context/dictionaryProvider";
import { debounce } from "../../../lib/util";
import { trackEvent } from "../../../lib/engageXClient";

const SearchAll = ({
  searchBoxClass,
  hideFilter = false,
  showSearchBar,
  searchPlaceholder,
}) => {
  const dict = useDictionary();
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const { replace } = useRouter();

  const handleSearch = debounce((key, term) => {
    if (key === "query" && term) trackEvent("search", { search_term: term, search_location: pathname?.includes("/blog") ? "blog" : "listing" });
    if (key === "sort") trackEvent("filter_apply", { filter_type: "sort", value: term || "none" });
    const params = new URLSearchParams(searchParams);
    if (term) {
      params.set(key, term);
    } else {
      params.delete(key);
    }
    replace(`${pathname}?${params.toString()}`, { scroll: false });
  }, 800);

  const handleSort = (key) => {
    handleSearch("sort", key);
  };

  const sortHead = () => {
    return (
      <Stack className="justify-between">
        {dict?.courses?.filters.sortBy}
        {/* <span onClick={() => handleSearch("sortBy", null)}>
          <X />
        </span> */}
      </Stack>
    );
  };

  return (
    <SearchBox className={searchBoxClass}>
      {showSearchBar && (
        <SearchInput
          placeholder={searchPlaceholder || dict?.courses?.search}
          size="md"
          endContent={
            <SearchIcon className="w-5 h-5 md:w-[30px] md:h-[30px]" />
          }
          type="search"
          classNames={{
            base: "blogSearchGroup w-full md:w-[530px] max-w-full",
            inputWrapper: "searchInput h-[44px] md:h-[57px] ",
            mainWrapper: "inputGroup",
            input: "dfd",
          }}
          onChange={(e) => handleSearch("query", e.target.value)}
          defaultValue={searchParams.get("query")?.toString()}
        />
      )}
      {!hideFilter && <FilterCourses />}

      {/* <SortingIcon /> */}
      <Dropdown placement="bottom-end">
        <DropdownTrigger>
          <div className="blogFilter px-2 py-2 md:py-[17px] md:px-[27px]">
            {<SortBy classNames="p-[2px] md:p-[0]" />}
          </div>
        </DropdownTrigger>
        <DropdownMenu
          DropdownMenu
          aria-label="Profile Actions"
          variant="flat"
          onAction={handleSort}
        >
          <DropdownSection title={sortHead()}>
            <DropdownItem key="alphabets">
              {dict?.courses?.filters?.aToZ}
            </DropdownItem>
            <DropdownItem key="new">{dict?.courses?.filters?.new}</DropdownItem>
            <DropdownItem key="popular">
              {dict?.courses?.filters?.popular}
            </DropdownItem>
          </DropdownSection>
        </DropdownMenu>
      </Dropdown>
    </SearchBox>
  );
};

export default SearchAll;
